import React from 'react';
import { connect, type ConnectedProps } from 'react-redux';
import cx from 'classnames';
import { yieldCallback } from '@zillow/yield-callback';

import Text from 'app/shared/core/Text';
import './style.scss';

const connector = connect();
type PropsFromRedux = ConnectedProps<typeof connector>;

type MapRemoveBorderButtonProps = PropsFromRedux & {
  mapType?: string | null;
  removeBorder?: () => void;
};

class MapRemoveBorderButton extends React.Component<MapRemoveBorderButtonProps> {
  static defaultProps = {
    mapType: null,
    removeBorder: (): void => {
      // noop default
    },
  };

  constructor(props: MapRemoveBorderButtonProps) {
    super(props);

    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  handleYieldButtonClick = yieldCallback(() => {
    const { removeBorder } = this.props;
    removeBorder?.();
  });

  handleButtonClick() {
    this.handleYieldButtonClick();
  }

  render() {
    const { mapType } = this.props;

    return (
      <div className="MapRemoveBorderBtn-top-right">
        <div
          className={cx({
            'MapRemoveBorderBtn-boundary-button': true,
            'MapRemoveBorderBtn-boundary-button-satellite': mapType === 'satellite',
          })}
          onClick={this.handleButtonClick}
        >
          <Text size="tiny">Remove border</Text>
        </div>
      </div>
    );
  }
}

export default connector(MapRemoveBorderButton);
